// extracted by mini-css-extract-plugin
module.exports = {"message":"noData_message__1Y028"};